import { useState } from 'react';
import styles from './ReportDismissedSection.module.scss';
import { CYPRESS_DATA } from './constants';
import TerminatedEmployeeMobileCard from './TerminatedEmployeeMobileCard';
import { EmployeeRow } from './types';
import { RegisterDismissedUiTexts } from './texts';

type Props = {
  rows: EmployeeRow[];
  texts: RegisterDismissedUiTexts;
  onRemove: (fieldId: string) => void;
};

const TerminatedEmployeesListMobile = ({ rows, texts, onRemove }: Props) => {
  const [expandedIds, setExpandedIds] = useState<string[]>([]);

  const toggleExpanded = (fieldId: string) =>
    setExpandedIds((current) =>
      current.includes(fieldId)
        ? current.filter((id) => id !== fieldId)
        : [...current, fieldId]
    );

  return (
    <ul className={styles.mobileList} data-cy={CYPRESS_DATA.mobileList}>
      {rows.map((row) => (
        <TerminatedEmployeeMobileCard
          key={row.fieldId}
          row={row}
          texts={texts}
          isExpanded={expandedIds.includes(row.fieldId)}
          onToggleExpanded={() => toggleExpanded(row.fieldId)}
          onRemove={() => onRemove(row.fieldId)}
        />
      ))}
    </ul>
  );
};

export default TerminatedEmployeesListMobile;
